export const absedFormula = fullString => {
    return fullString ? fullString.replace(/a/g, 'abs(') : fullString;
};

export const fromAbsedString = absedString => {
    return absedString ? absedString.replace(/abs\(/g, 'a') : absedString;
};

export const removeImplicitMultiplication = formulaString => {
    let formulaWithoutImplicitMul = '';
    let previousChar = '';
    for (const char of formulaString) {
        if (
            (/[0-9]/.test(previousChar) && /[ap(]/.test(char)) || // E.g. "432p", "123a(p)", "32(p-0.2)"
            (/[)p]/.test(previousChar) && /[0-9]|[ap(]/.test(char)) // E.g. "(12)a(2)", "(12)p", "(12)(-p)", "p32"
        ) {
            formulaWithoutImplicitMul += '*';
        }
        formulaWithoutImplicitMul += char;
        previousChar = char;
    }
    return formulaWithoutImplicitMul;
};
